import { lazyLoading } from "./libs/deferring";

document.addEventListener("DOMContentLoaded", () => {
    // Enable lazy loading
    lazyLoading();
});